import { PublicRanking } from "@/components/PredictionMarket/PublicRanking";
import { ResultCardListItem } from "@/components/PredictionMarket/ResultCardListItem";

export const MyPredictionMarketResultPage = () => {
  return (
    <>
      <div className="w-full bg-[#01A4F9]">
        <div className="p-5">
          <h1 className="text-xl font-bold text-white">あなたの結果</h1>
        </div>
        <div className="p-5 grid gap-5">
          <ResultCardListItem
            title="ボストン・セルティックスは2024-2025年のNBAチャンピオンになる？"
            tag="建築"
            isCorrect={true}
            points={180000}
            betAmount={300}
            winnings={495}
            ranking={1000}
            expiredAt={1717507200}
          />
          <ResultCardListItem
            title="ボストン・セルティックスは2024-2025年のNBAチャンピオンになる？"
            tag="建築"
            isCorrect={false}
            points={180000}
            betAmount={300}
            winnings={495}
            ranking={1000}
            expiredAt={1717507200}
          />
        </div>
      </div>
      <div className="w-full bg-white">
        <div className="p-5 pt-10">
          <h1 className="text-xl font-bold">最近の結果</h1>
        </div>
        <div className="p-5 grid gap-5">
          <ResultCardListItem
            title="ボストン・セルティックスは2024-2025年のNBAチャンピオンになる？"
            tag="建築"
            isCorrect={true}
            points={180000}
            betAmount={300}
            winnings={495}
            ranking={1000}
            expiredAt={1717507200}
            rankingComponent={
              <PublicRanking
                users={[
                  { id: "1", name: "shadcn1", thumbnail: "https://github.com/shadcn.png", points: 100 },
                  { id: "2", name: "shadcn2", thumbnail: "https://github.com/shadcn.png", points: 100 },
                  { id: "3", name: "shadcn3", thumbnail: "https://github.com/shadcn.png", points: 100 },
                ]}
              />
            }
          />
          <ResultCardListItem
            title="ボストン・セルティックスは2024-2025年のNBAチャンピオンになる？"
            tag="建築"
            isCorrect={false}
            points={180000}
            betAmount={300}
            winnings={495}
            ranking={1000}
            expiredAt={1717507200}
            rankingComponent={
              <PublicRanking
                users={[
                  { id: "1", name: "shadcn1", thumbnail: "https://github.com/shadcn.png", points: 100 },
                  { id: "2", name: "shadcn2", thumbnail: "https://github.com/shadcn.png", points: 100 },
                  { id: "3", name: "shadcn3", thumbnail: "https://github.com/shadcn.png", points: 100 },
                ]}
              />
            }
          />
        </div>
      </div>
    </>
  );
};
